'use client'

/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React from 'react'
import WidgetModal from '@components/WidgetModal/WidgetModal'
import {
  PRODUCT_WIDGETS_VS_COMPONENTS,
  NON_RESPONSIVE_WIDGET,
  getAutoWidgetLayout,
  DISABLE_USPS,
} from '@configs/productWidget.config'
import PropertyControlledComponent from '@components/PropertyControlledComponent/PropertyControlledComponent'
import { getClassNames } from '@helpers/productWidgetHelper'
import KeyFeatures from './keyFeatures'
import ProductLobWidget from './subComponents/productLobWidget'
import ProductCTAButtonAndDisclaimer from './subComponents/ProductCtaAndDisclaimer'
import styles from './productWidget.module.scss'

const ProductWidgetNewLayout = ({
  isMobileDevice,
  data,
  segmentEventCommonProperties,
  reqCookie,
  isSemPage,
  productWidgetData,
  combinedStyles,
  regexPatternsData,
}) => {
  const content = data?.data?.attributes
  const Component = PRODUCT_WIDGETS_VS_COMPONENTS[content?.widget]
  const isAutoWidgetLayout = getAutoWidgetLayout[content?.widget]
  const THEME_CONFIG = {
    light: styles.lightTheme,
    dark: '',
  }

  const containerClassNames = getClassNames([styles.productWidgetMainContainer], {
    [styles.semPageHeader]: isSemPage && !isAutoWidgetLayout,
  })

  return (
    <div id="productWidget" className={containerClassNames}>
      <div className={styles.titleAndKeyFeatures}>
        <div className={`${styles.newLayoutHeading} ${THEME_CONFIG[content?.theme]}`}>
          {content?.productWidgetMainHeading}
        </div>
        <p className={`${styles.subHeading} ${THEME_CONFIG[content?.theme]}`}>{content?.ProductWidgetSubHeading}</p>

        <PropertyControlledComponent
          fallback={null}
          controllerProperty={isSemPage || !DISABLE_USPS.includes(content?.widget)}>
          <div>
            <KeyFeatures
              keyFeaturesData={content?.KeyFeatures}
              isMarginRequired={isAutoWidgetLayout}
              themeClassname={THEME_CONFIG[content?.theme]}
            />
          </div>
        </PropertyControlledComponent>

        <ProductCTAButtonAndDisclaimer content={content} segmentEventCommonProperties={segmentEventCommonProperties} />
      </div>

      <ProductLobWidget
        content={content}
        isMobileDevice={isMobileDevice}
        segmentEventCommonProperties={segmentEventCommonProperties}
        reqCookie={reqCookie}
        isSemPage={isSemPage}
        isOldLayout={false}
        combinedStyles={combinedStyles}
        regexPatternsData={regexPatternsData}
        widgetOptions={content?.widgetOptions}
        widgetVisibleAlways
        isNewBackgroundImgLayout
      />

      {content && NON_RESPONSIVE_WIDGET.includes(content?.widget) && (
        // This div is required for health-widget right overflow
        <div>
          <Component isMobileDevice={isMobileDevice} segmentEventCommonProperties={segmentEventCommonProperties} />
        </div>
      )}

      <WidgetModal
        content={content}
        bottomFloaterWidgetCta={content?.widget}
        segmentEventCommonProperties={segmentEventCommonProperties}
        reqCookie={reqCookie}
        isSemPage={isSemPage}
        productWidgetData={productWidgetData}
        regexPatternsData={regexPatternsData}
        isMobileDevice
      />
    </div>
  )
}

export default ProductWidgetNewLayout
